/**
 * Garde qui redirige vers la page maintenance si le mode maintenance est actif.
 * Exempte : /maintenance et /admin (pour permettre aux admins de désactiver le mode).
 * @module components/auth/MaintenanceGuard
 */

import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, Outlet } from 'react-router-dom';
import { isMaintenanceMode } from '../../services/appConfigService';

const EXEMPT_PATHS = ['/maintenance', '/admin'];

function MaintenanceGuard() {
  const location = useLocation();
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);
  const [, setMaintenanceActive] = useState(false);

  const currentPath = location.pathname;
  const isExempt = EXEMPT_PATHS.some(
    (path) => currentPath === path || currentPath.startsWith(path + '/')
  );

  useEffect(() => {
    if (isExempt) {
      setChecking(false);
      setMaintenanceActive(false);
      return;
    }

    let cancelled = false;

    const check = async () => {
      try {
        const active = await isMaintenanceMode();
        if (!cancelled) {
          setMaintenanceActive(active);
          if (active) {
            navigate('/maintenance', { replace: true });
          }
        }
      } catch {
        if (!cancelled) {
          setMaintenanceActive(false);
        }
      } finally {
        if (!cancelled) {
          setChecking(false);
        }
      }
    };

    check();
    return () => {
      cancelled = true;
    };
  }, [currentPath, isExempt, navigate]);

  if (checking && !isExempt) {
    return (
      <div
        className="page-container"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          background: 'var(--color-bg-primary)',
        }}
      >
        <div
          style={{
            width: 40,
            height: 40,
            border: '3px solid var(--color-border-subtle)',
            borderTopColor: 'var(--color-twitch-primary)',
            borderRadius: '50%',
            animation: 'spin 0.7s linear infinite',
          }}
        />
      </div>
    );
  }

  return <Outlet />;
}

export default MaintenanceGuard;
